import DashboardHeader from './components/DashboardHeader';
import './dashboard.scss';
import DashboardItems from './components/DashboardItems';
import HelpeResource from './components/HelpeResource';
import AdditionalOptions from './components/AdditionalOptions';
import ContactUs from './components/ContactUs';
import NewsCenter from './components/NewsCenter';
import MessageCenter from './components/MessageCenter';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MaintainanceNotification from './components/MaintainanceNotification';
import React from 'react';
import { useMaintenanceNotificationMutation } from '../../features/authentication/authApiSlice';
import { useGetSchoolDistrictInfoMutation } from '../../features/authentication/dashboardHeaderApiSlice';
import { useDashboardContext } from '../dashboard/context';
import { useCheckVerifyInfoDialogShownMutation } from '../../features/authentication/persistApiSlice';
import { useLazyGetProfileInformationQuery } from '../../features/componentEndpoints/profileInformationEndpoints';
import ProfileInfoComponent from '../profileInfoModal/profileInfoComponent';
import success from '../../assets/images/success.png';
import SuccessModal from '../../components/SuccessModal';
import { useSelector } from 'react-redux';
import { selectCurrentUserData, selectCurrentCenter } from '../../features/authentication/authSlice';
import UserTypes from '../../enums/userTypes';
import { getCenterById } from '../../enums/centerTypes';

const Welcome = () => {
  const [maintenanceNotification] = useMaintenanceNotificationMutation();
  const [maintenanceData, setMaintenanceData] = React.useState(null);
  const [schoolName, setSchoolName] = React.useState('');
  const [districtName, setDistrictName] = React.useState('');
  const [getSchoolInfo] = useGetSchoolDistrictInfoMutation();
  const [profileData, setProfileData] = React.useState({});
  const [showVerifyInfo, setShowVerifyInfo] = React.useState(false);
  const [getShowVerification] = useCheckVerifyInfoDialogShownMutation();
  const [trigger] = useLazyGetProfileInformationQuery(); 
  const dashboardContext = useDashboardContext();
  const user = useSelector(selectCurrentUserData);
  const currentCenter = useSelector(selectCurrentCenter);
  const selectedCenterTitle = getCenterById(currentCenter).title;

  React.useEffect(() => {
    maintenancHandler();
    getSchoolDistrictInfoAsync();
    if(user.UserType == UserTypes.Teacher || user.UserType == UserTypes.HomeTeacher)
      getShowProfileInformation();
  }, []);

  React.useEffect(() => {
    getSchoolDistrictInfoAsync();
  }, [dashboardContext.isSchoolChange]);

  const getShowProfileInformation = async ()=>{
    try{
      const response = await getShowVerification().unwrap();
      if(!response.verifyInfoDialogShown){
        trigger().then((response) => {
          if (!response.isSuccess) {
            return;
          }
          setProfileData(response.data);
          setShowVerifyInfo(true);
        });
      }
    }
    catch(error){
      console.log(error);
    }
  };

  const getSchoolDistrictInfoAsync = async () => {
    const response = await getSchoolInfo();
    setDistrictName(response.data.districtName);
    setSchoolName(response.data.schoolName);
  };

  const maintenancHandler = async () => {
    try{
      const response = await maintenanceNotification(currentCenter);
      if(response.data?.isActive){
        setMaintenanceData(response.data);
      }
    } catch (ex){
      console.log(ex);
    }
  };

  return (
    <>
      <div className="dashboard_main_wrapper">
        {maintenanceData?.isActive &&
          <MaintainanceNotification
            message={maintenanceData.message}
          />
        }
        <section className="welcome">
          <DashboardHeader />
          <div className="row dashboard_second_header m-0 mb-4 p-3">
            <div className="col-lg-4 text-center border-end">
              {districtName != '' ? districtName + ' District' : 'District Name'}
            </div>
            <div className="col-lg-4 text-center border-end">
              {schoolName != '' ? schoolName : 'School Name'}
            </div>
            <div className="col-lg-4 text-center ">{selectedCenterTitle}</div>
          </div>
          <DashboardItems />
          <HelpeResource />
          <div className="row">
            <div className="col-lg-6">
              <AdditionalOptions />
              <MessageCenter />
              <NewsCenter />
            </div>
            <ContactUs />
          </div>
        </section>
        <div className="col-12 info-text d-flex align-items-center">
          <span>
            <FontAwesomeIcon icon={faInfo} />
          </span>
          <p>
            Please remember to &quot;Logout&quot; when you are done. For best results, do not use
            your browser&apos;s BACK and FORWARD buttons while on Castle Learning.
          </p>
        </div>
      </div>
      {showVerifyInfo &&
      <ProfileInfoComponent
        isOpen={showVerifyInfo}
        onClose={()=> setShowVerifyInfo(false)}
        profileData={profileData}
      />
      }
      {dashboardContext.profileUpdateSuccess &&
      <SuccessModal
        isOpen={dashboardContext.profileUpdateSuccess}
        onClose={() => dashboardContext.setProfileUpdateSuccess(false)}
        contentWidth={'50%'}
        content='Your email and settings have been saved.'
        icon={success}
      />
      }
    </>
  );
};

export default Welcome;
